import { useCallback } from 'react';
import { Flex, Icon, HStack, Text } from '@chakra-ui/react';
import { ArrowUp, ArrowDown } from 'lucide-react';
import { SortOrder } from '@duke-hq/lib/pagination';

export function SortableHeader({
  label,
  columnName,
  currentOrderBy,
  currentSortOrder,
  onSortChange,
}: {
  label: string;
  columnName: string;
  currentOrderBy?: string;
  currentSortOrder?: SortOrder;
  onSortChange: (columnName: string) => void;
}) {
  const handleClick = useCallback(() => {
    onSortChange(columnName);
  }, [columnName, onSortChange]);

  return (
    <Flex justify="space-between" align="center" onClick={handleClick} cursor="pointer">
      <HStack spacing="5">
        <Text>{label}</Text>
        {currentOrderBy === columnName &&
          (currentSortOrder === SortOrder.DESC ? (
            <Icon
              as={ArrowDown}
              color={currentOrderBy === columnName ? 'purple.500' : 'fg.muted'}
              boxSize="4"
            />
          ) : currentSortOrder === SortOrder.ASC ? (
            <Icon
              as={ArrowUp}
              color={currentOrderBy === columnName ? 'purple.500' : 'fg.muted'}
              boxSize="4"
            />
          ) : null)}
      </HStack>
    </Flex>
  );
}

SortableHeader.displayName = 'SortableHeader';
